import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgChartsModule } from 'ng2-charts';

import { ManagerReportChartComponent } from './manager-report-chart.component';

@NgModule({
  imports: [
    // Minga dependencies

    // External dependencies
    CommonModule,
    NgChartsModule,
  ],
  declarations: [ManagerReportChartComponent],
  exports: [ManagerReportChartComponent],
})
export class ManagerReportChartModule {}
